export default {
  m: 'male',
  f: 'female',
  n: 'neutral',
  pl: 'Plural',
};
